import { AlgoliaQuery } from 'ha/services/algolia';
import { filterBuilder } from 'ha/modules/Algolia';
import getGeoBoundaryFilter from './getGeoBoundaryFilter';
import getFilterParams from './getFilterParams';
import { ReqParams, SearchParams, CurrencyEuroRates } from './types';

const queryFilterBuilder = filterBuilder();

export default (
  reqParams: ReqParams,
  searchParams: SearchParams,
  currencyEuroRates: CurrencyEuroRates,
): AlgoliaQuery => {
  const geoBoundaryFilter = getGeoBoundaryFilter(reqParams, searchParams);
  const filterParams = getFilterParams(reqParams, currencyEuroRates);
  const filters = queryFilterBuilder(filterParams);

  return {
    query: '',
    params: {
      distinct: true,
      insideBoundingBox: geoBoundaryFilter,
      filters,
      hitsPerPage: 1000,
      attributesToRetrieve: ['internalID', '_geoloc'],
      attributesToHighlight: [],
    },
  };
};
